import React from "react";

function TeamMembers() {
  return (
    <div>
      <section className="team-two-section ptb-100 ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-9 col-lg-8">
              <div className="section-heading text-center">
                <h2>Our Team Members</h2>
                <p>
                  Authoritatively mesh intuitive paradigms vis-a-vis
                  goal-oriented partnerships. Continually extend open-source
                  outside the box thinking after focused catalysts.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                <img
                  src="assets/img/team/team-member-1.png"
                  alt="team image"
                  width="120"
                  className="img-fluid m-auto pb-4"
                />
                <div className="team-content">
                  <h5 className="mb-0">Richard Ford</h5>
                  <span>Instructor of Mathematics</span>
                  <p className="mt-3">
                    Authoritatively engage leading-edge processes tactical
                    capital{" "}
                  </p>
                  <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                    <li className="list-inline-item">
                      <a className="facebook" href="#" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="twitter" href="#" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="dribbble" href="#" target="_blank">
                        <i className="fab fa-dribbble"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="linkedin" href="#" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                <img
                  src="assets/img/team/team-member-2.png"
                  alt="team image"
                  width="120"
                  className="img-fluid m-auto pb-4"
                />
                <div className="team-content">
                  <h5 className="mb-0">Kely Roy</h5>
                  <span>Lead Designer</span>
                  <p className="mt-3">
                    Monotonectally engage sticky collaborative markets
                    synergistically
                  </p>
                  <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                    <li className="list-inline-item">
                      <a className="facebook" href="#" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="twitter" href="#" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="dribbble" href="#" target="_blank">
                        <i className="fab fa-dribbble"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="linkedin" href="#" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                <img
                  src="assets/img/team/team-member-3.png"
                  alt="team image"
                  width="120"
                  className="img-fluid m-auto pb-4"
                />
                <div className="team-content">
                  <h5 className="mb-0">Gerald Nichols</h5>
                  <span>Managing Director</span>
                  <p className="mt-3">
                    Assertively procrastinate standardized whereas technically
                    sound
                  </p>
                  <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                    <li className="list-inline-item">
                      <a className="facebook" href="#" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="twitter" href="#" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="dribbble" href="#" target="_blank">
                        <i className="fab fa-dribbble"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="linkedin" href="#" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="single-team-wrap bg-white text-center border rounded p-4 mt-4">
                <img
                  src="assets/img/team/team-member-4.png"
                  alt="team image"
                  width="120"
                  className="img-fluid m-auto pb-4"
                />
                <div className="team-content">
                  <h5 className="mb-0">Gerald Nichols</h5>
                  <span>Team Manager</span>
                  <p className="mt-3">
                    Synergistically actualize out the-box technologies before
                    parallel process
                  </p>
                  <ul className="list-inline social-list-default social-color icon-hover-top-bottom">
                    <li className="list-inline-item">
                      <a className="facebook" href="#" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="twitter" href="#" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="dribbble" href="#" target="_blank">
                        <i className="fab fa-dribbble"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a className="linkedin" href="#" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TeamMembers;
